








































import { Component, Prop, Vue } from 'vue-property-decorator';
import { User } from "@/components/User";

@Component
export default class Login extends Vue {
  private username: string = '';
  private password: string = '';
  private errorMessage: string = null;
  
  get page() : string {
    return this.$store.getters.Page;
  };
  
  async login() {
    try {
      let user = new User();
      let ok = await user.login(this.username, this.password);
      this.$store.commit('notifyChange', {
        //User: user.StateProperties,
        User: user, // .Properties,
        Page:'land'
      });
    } catch (error) {
      this.errorMessage = 'loginWasNotSuccessful';
    }
  }
}
